import { Util } from "./utils";

export class Tab {
    constructor(element) {
        this.element = element;
        this.tabList = this.element.querySelector('.js-tabs__controls');
        this.listItems = Array.from(this.tabList.querySelectorAll('li'));
        this.triggers = Array.from(this.tabList.querySelectorAll('a'));
        this.panelsList = this.element.querySelector('.js-tabs__panels');
        this.panels = Util.getChildrenByClassName(this.panelsList, 'js-tabs__panel');
        this.hideClass = this.element.getAttribute('data-hide-panel-class') || 'js-tabs__panel--hidden';
        this.customShowClass = this.element.getAttribute('data-show-panel-class') || false;
        this.layout = this.element.getAttribute('data-tabs-layout') || 'horizontal';
        this.deepLinkOn = this.element.getAttribute('data-deep-link') === 'on';
        this.initTab();
    }
  
    initTab() {
        this.tabList.setAttribute('role', 'tablist');
        this.element.classList.add('tabs--no-interaction');
    
        this.triggers.forEach((trigger, index) => {
            const bool = index === 0;
            const panelId = this.panels[index].getAttribute('id');
            this.listItems[index].setAttribute('role', 'presentation');
            Util.setAttributes(trigger, {
                role: 'tab',
                'aria-selected': bool,
                'aria-controls': panelId,
                id: `tab-${panelId}`,
            });
            Util.addClass(trigger, 'js-tabs__trigger');
            Util.setAttributes(this.panels[index], {
                role: 'tabpanel',
                'aria-labelledby': `tab-${panelId}`,
            });
            Util.toggleClass(this.panels[index], this.hideClass, !bool);
            if (bool && this.customShowClass) Util.addClass(this.panels[index], this.customShowClass);
    
            if (!bool) trigger.setAttribute('tabindex', '-1');
        });
    
        this.initTabEvents();
        this.initDeepLink();
    }
  
    initTabEvents() {
        this.tabList.addEventListener('click', (event) => {
            if (event.target.closest('.js-tabs__trigger')) this.triggerTab(event.target.closest('.js-tabs__trigger'), event);
        });
    
        this.tabList.addEventListener('keydown', (event) => {
            if (!event.target.closest('.js-tabs__trigger')) return;

            if (tabNavigateNext(event, this.layout)) {
                event.preventDefault();
                this.selectNewTab('next');
            } else if (tabNavigatePrev(event, this.layout)) {
                event.preventDefault();
                this.selectNewTab('prev');
            }
        });
    }
  
    selectNewTab(direction) {
        const selectedTab = this.tabList.querySelector('[aria-selected="true"]');
        let index = Util.getIndexInArray(this.triggers, selectedTab);
        index = direction === 'next' ? index + 1 : index - 1;
    
        if (index < 0) index = this.listItems.length - 1;
        if (index >= this.listItems.length) index = 0;
        
        this.triggerTab(this.triggers[index]);
        this.triggers[index].focus();
    }
  
    triggerTab(tabTrigger, event) {
        event && event.preventDefault();
        const index = Util.getIndexInArray(this.triggers, tabTrigger);
    
        if (this.triggers[index].getAttribute('aria-selected') === 'true') return;
    
        this.element.classList.remove('tabs--no-interaction');
    
        this.triggers.forEach((trigger, i) => {
            const bool = i === index;
            Util.toggleClass(this.panels[i], this.hideClass, !bool);
            if (this.customShowClass) Util.toggleClass(this.panels[i], this.customShowClass, bool);
            trigger.setAttribute('aria-selected', bool);
            bool ? trigger.setAttribute('tabindex', '0') : trigger.setAttribute('tabindex', '-1');
        });
    
        if (this.deepLinkOn) {
            history.replaceState(null, '', `#${tabTrigger.getAttribute('aria-controls')}`);
        }
    }
  
    initDeepLink() {
        if (!this.deepLinkOn) return;
        const hash = window.location.hash.substr(1);
        if (!hash || hash === '') return;
        
        for (let i = 0; i < this.panels.length; i++) {
            if (this.panels[i].getAttribute('id') === hash) {
                this.triggerTab(this.triggers[i], false);
                setTimeout(() => { this.panels[i].scrollIntoView(true); });
                break;
            }
        }
    }
}
  
function tabNavigateNext(event, layout) {
    if (layout === 'horizontal' && (event.keyCode && event.keyCode === 39 || event.key && event.key === 'ArrowRight')) {
        return true;
    } else if (layout === 'vertical' && (event.keyCode && event.keyCode === 40 || event.key && event.key === 'ArrowDown')) {
        return true;
    } else {
        return false;
    }
}

function tabNavigatePrev(event, layout) {
    if (layout === 'horizontal' && (event.keyCode && event.keyCode === 37 || event.key && event.key === 'ArrowLeft')) {
        return true;
    } else if (layout === 'vertical' && (event.keyCode && event.keyCode === 38 || event.key && event.key === 'ArrowUp')) {
        return true;
    } else {
        return false;
    }
} 
